import { Route, Routes, useNavigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext.jsx";

import ReportBank from "./components/ReportBank.jsx";
import ReportCash from "./components/ReportCash.jsx";
import ReportCustomerDetail from "./components/ReportCustomerDetail.jsx";
import ReportDaily from "./components/ReportDaily.jsx";
import ReportFinance from "./components/ReportFinance.jsx";
import ReportPL from "./components/ReportPL.jsx";
import ReportSales from "./components/ReportSales.jsx";

import HomePage from "./pages/HomePage.jsx";
import Login from "./pages/login/index.jsx";
import MegaMenu from "./pages/MegaMenu.jsx";
import MegaMenu2 from "./pages/MegaMenu2.jsx";
import Register from "./pages/register/index.jsx";
import ReportPage from "./pages/ReportPage.jsx";

import KPILogin from "./pages/KPI/login/index.jsx";
import KPIDashboard from "./pages/KPI/dashboard/index.jsx";

function App() {
  const dataLogin = JSON.parse(localStorage.getItem("dataLogin"));

  // const navigate = useNavigate();
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <AuthProvider>
            <div>
              <div>
                <Routes>
                  <Route path="/" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route
                    path="/*"
                    element={
                      <>
                        <MegaMenu2 />
                        <Routes>
                          <Route
                            path="/home"
                            element={<HomePage dataLogin={dataLogin} />}
                          />
                          <Route path="/reports" element={<ReportPage />} />
                        </Routes>
                      </>
                    }
                  />
                  <Route
                    path="report/*"
                    element={
                      <>
                        <MegaMenu />
                        <Routes>
                          <Route path="/cash" element={<ReportCash />} />
                          <Route path="/bank" element={<ReportBank />} />
                          <Route path="/PL" element={<ReportPL />} />
                          <Route path="/sales" element={<ReportSales />} />
                          <Route path="/daily" element={<ReportDaily />} />
                          <Route
                            path="/customerdetail"
                            element={<ReportCustomerDetail />}
                          />
                          <Route path="/finance" element={<ReportFinance />} />
                        </Routes>
                      </>
                    }
                  />
                </Routes>
              </div>
            </div>
          </AuthProvider>
        }
      ></Route>

      <Route
        path="kpi/*"
        element={
          <AuthProvider>
            {/* <div className="container mx-auto p-4 pt-6 md:p-6 dark:bg-gray-900 min-h-screen"> */}
            <Routes>
              <Route path="/" element={<KPILogin />} />
              <Route path="/Login" element={<KPILogin />} />
              <Route path="/Dashboard" element={<KPIDashboard />} />
            </Routes>
            {/* </div> */}
          </AuthProvider>
        }
      >

      </Route>
    </Routes>
  );
}

export default App;
